import { SET_BOOKING_COMPLETED, SET_BOOKING } from './bookings.actions';

const initialState = {
  booking: null,
  isBookingCompleted: false,
};

export const bookingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BOOKING_COMPLETED:
      return {
        ...state,
        isBookingCompleted: payload,
      };

    case SET_BOOKING: {
      return {
        ...state,
        booking: payload,
        isBookingCompleted: !!payload,
      };
    }
    default:
      return state;
  }
};
